import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MuiButtonAppearanceEnum, MuiModalService } from '@move/ui';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CUSTOM_HEADER_PREFIX } from './custom-header-prefix';
import { MmuApiBaseService } from './mmu-api-base.service';

@Injectable()
export class MmuAuthInterceptor implements HttpInterceptor {
  static readonly ignoreHeader = CUSTOM_HEADER_PREFIX + '-ignore-auth-interception';

  protected readonly i18n = {
    // Make sure translation keys required will not be ignored by ngx-translate-extract by using the marker function
    title: 'global.error.request.unauthorized.title',
    msg: 'global.error.request.unauthorized.message',
    button: 'global.error.request.unauthorized.button'
  };

  constructor(protected api: MmuApiBaseService, protected translate: TranslateService, protected modalService: MuiModalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept API requests that did not add the MmuAuthInterceptor.ignoreHeader
    if (this.api.isApiRequest(req) && !req.headers.has(MmuAuthInterceptor.ignoreHeader)) {
      return next.handle(req).pipe(
        catchError((err, caught) => {
          // Request user authentication is case of a 401 response
          if (err instanceof HttpErrorResponse && err.status === 401) {
            this.requestAuthentication();
          }

          return throwError(err);
        })
      );
    } else {
      // Do not intercept requests that are not API requests (e.g. static content)
      return next.handle(req);
    }
  }

  /**
   * Display an error dialog that forces the user to login again.
   */
  private requestAuthentication(): void {
    this.translate.get([this.i18n.msg, this.i18n.title, this.i18n.button]).subscribe((i18n) => {
      const modal = this.modalService.openBasicModal(i18n[this.i18n.msg], i18n[this.i18n.title], {
        backdrop: 'static',
        confirmButton: {
          label: i18n[this.i18n.button],
          appearance: MuiButtonAppearanceEnum.DANGER
        },
        keyboard: false,
        showCloseButton: false,
        dismissButton: false
      });

      // Force page reload to redirect to login page in any case
      modal.result.then(
        () => window.location.reload(),
        () => window.location.reload()
      );
    });
  }
}
